module.exports = "<h2>Mike Plummer</h2><div class=\"fragment\"><span class=\"row\"><img class=\"small-img\" src=\"" + require("../../../resources/images/opi-logo.png") + "\"/><h3>Object Partners, Inc.</h3></span></div><div class=\"fragment\"><span class=\"row\"><img class=\"small-img\" src=\"" + require("../../../resources/images/twitter-logo.png") + "\"/><h3>@plummer_mike</h3></span></div><div class=\"fragment\"><span class=\"row\"><img class=\"small-img\" src=\"" + require("../../../resources/images/github-logo.png") + "\"/><h3>mike-plummer</h3></span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/01-bio/02.pug
// module id = 317
// module chunks = 1